import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarCndAutomaticaDs,
  criarContribuinteDs,
  criarImovelDs,
  criarCpbsDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import CpbsBox from "../cpbs/CpbsBox";
import ImovelBox from "../imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import api from "../../api-axios";
import ShowError from "../../AppServices";
import showReport from "../../showReport";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  imovelId: undefined,
  cpbsId: undefined,
  inscricao: undefined,
  tipoCadastro: "C",
  popupVisivel: false,
};

export default class CertidaoNegativaAutomatica extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cndDs = criarCndAutomaticaDs();
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.cpbsDs = criarCpbsDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.tiposCadastroDs = [
      { id: "C", descricao: "Contribuinte" },
      { id: "E", descricao: "CPBS" },
      { id: "I", descricao: "Imóvel" },
    ];

    this.tipoCadastroOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: this.tiposCadastroDs,
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) =>
        this.setState({
          tipoCadastro: e.value,
          _uiNome: "",
          inputId: undefined,
        }),
    };

    //Funções do input
    /*
    /*
    */
    this.setInputId = this.setInputId.bind(this);
    this.pesquisarRegistro = this.pesquisarRegistro.bind(this);
    this.onRegistroSelecionadoPesquisa =
      this.onRegistroSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.cpbsBoxRef = React.createRef();
    this.imovelBoxRef = React.createRef();
    this.renderInput = sysCodigoDescricao(
      () => this.state.inputId,
      this.setInputId,
      () => this.state._uiNome,
      this.pesquisarRegistro
    );
    this.setNomeErro = this.setNomeErro.bind(this);
    /*
   /*
   */
    //Fim da funções do input
  }

  //Funções do input
  /*
  /*
  */

  setInputId(data) {
    let estado = {};
    Object.assign(estado, this.state);
    switch (this.state.tipoCadastro) {
      case "C":
        this.contribuinteDs
          .load({ filter: [["sequencial", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNome: "" });
              } else {
                Object.assign(estado, { _uiNome: result[0].nome });
              }
            } else {
              Object.assign(estado, { _uiNome: "" });
            }
            this.setState({
              ...estado,
              inputId: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
      case "E":
        this.cpbsDs
          .load({ filter: [["inscricao", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNome: "" });
              } else {
                Object.assign(estado, { _uiNome: result[0].contribuinte.nome });
              }
            } else {
              Object.assign(estado, { _uiNome: "" });
            }
            this.setState({
              ...estado,
              inputId: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
      case "I":
        this.imovelDs
          .load({ filter: [["sequencial", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNome: "" });
              } else {
                Object.assign(estado, { _uiNome: result[0].enderecoCompleto });
              }
            } else {
              Object.assign(estado, { _uiNome: "" });
            }
            this.setState({
              ...estado,
              inputId: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
    }
  }

  setNomeErro() {
    this.setState({ _uiNome: "<<ERRO>>" });
  }

  onRegistroSelecionadoPesquisa(e) {
    let data = {};
    if (this.state.tipoCadastro === "C" || this.state.tipoCadastro === "I") {
      Object.assign(data, { value: e.row.data.sequencial.toString() });
    } else {
      Object.assign(data, { value: e.row.data.inscricao.toString() });
    }
    this.setInputId(data);
  }

  pesquisarRegistro() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.cpbsBoxRef.current.limparFiltro();
    //this.imovelBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  /*
/*
*/
  //Fim da funções do input

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.cndDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("CND não encontrado.", "error");
              this.props.history.push("/certidaonegativa");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    let valor = this.tiposCadastroDs.find(
      (x) => x.id === this.state.tipoCadastro
    );
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="CERTIDÃO NEGATIVA AUTOMÁTICA"
              colSpan={2}
              colCount={4}
            >
              <SimpleItem
                dataField={"tipoCadastro"}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoCadastroOptions}
                colSpan={1}
              >
                <Label text="Tipo de Cadastro" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem colSpan={4} component={this.renderInput}>
                <Label text={`${valor.descricao}`} />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              border: "1px solid black",
              padding: "10px",
            }}
          >
            <p>
              <strong>Requisitos para certidão NEGATIVA:</strong>
            </p>
            <p>Nenhum crédito do EXERCÍCIO ATUAL vencido e não pago</p>
            <p>
              Nenhuma DÍVIDA ATIVA em situação de crédito EXIGÍVEL ou SUSPENSA
            </p>
            <br />
            <p>
              <strong>Requisitos para certidão POSITIVA:</strong>
            </p>
            <p>Nenhum crédito do EXERCÍCIO ATUAL vencido e não pago</p>
            <p>Nenhuma DÍVIDA ATIVA em situação de crédito EXIGÍVEL</p>
            <p>
              ACORDOS EXISTENTES devem ter PAGO o mínimo de parcelas necessárias
              conforme o CTM
            </p>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="danger"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => this.setState({ popupVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar"
        >
          <ScrollView showScrollbar={"always"}>
            <div
              style={{
                display: this.state.tipoCadastro === "C" ? "" : "none",
              }}
            >
              <ContribuinteBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </div>
            <div
              style={{
                display: this.state.tipoCadastro === "E" ? "" : "none",
              }}
            >
              <CpbsBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
                ref={this.cpbsBoxRef}
              />
            </div>
            <div
              style={{
                display: this.state.tipoCadastro === "I" ? "" : "none",
              }}
            >
              <ImovelBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
                //ref={this.imovelBoxRef}
              />
            </div>
          </ScrollView>

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = {
      ...this.state,
      prefeituraId: UserInfo.getPrefeitura(),
      tipoCadastro: this.state.tipoCadastro,
      inscricao: this.state.inputId,
    };

    api
      .post("/cnds/cnd_automatica", entidade)
      .then((resp) => {
        const data = resp.data;
        if (data.liberado) {
          showReport(`/report/cnd/${data.cnd.id}/${data.cnd.prefeituraId}`);
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.push("/certidaonegativa");
        } else {
          ShowError(
            "requisição atendida, mas CND não liberada, contate o suporte."
          );
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.erros
        ) {
          ShowError(error.response.data.erros);
        } else {
          ShowError(error.message);
        }
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
